import Stack from '@eversports/klimt-primitives/legacy/Stack'

import { Meta } from '../../App.types'

import Header from './Header'
import { Venue } from './VenueProfile.types'
import VenueProfileContent from './VenueProfileContent'
import VenueProfileHeaderContainer from './VenueProfileHeaderContainer'

interface Props {
  venue: Venue
  meta: Meta
}

const VenueProfileComponent = ({ venue, meta }: Props) => (
  <Stack
    sx={{
      backgroundColor: 'eggshell',
      justifyContent: 'center',
      alignItems: 'center',
    }}
    component="main"
  >
    <VenueProfileHeaderContainer>
      <Header venue={venue} />
    </VenueProfileHeaderContainer>
    <VenueProfileContent venue={venue} meta={meta} />
  </Stack>
)

export default VenueProfileComponent
